import React, { Component } from 'react';
import { connect } from 'react-redux'
import {closePopup} from "../../../actions/popup";
import autobind from 'autobind-decorator'
import ClearDataResultPopup from './ClearDataResultPopup';
import CloseBlogResultPopup from "./CloseBlogResultPopup";
import WindowEventHelper from "../../../lib/WindowEventHelper";

@connect(state => ({
    isPopupOpened: (typeof state.popup !== 'undefined' && state.popup.clearDataResultPopupOpened)
    || (typeof state.popup !== 'undefined' && state.popup.closeBlogResultPopupOpened)
}), dispatch => ({
    handlePopupClose: () => {
        dispatch(closePopup())
    },
}))
class BlogDataPopupLayer extends Component {
    componentWillUnmount() {
        document.body.className = "";
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isPopupOpened) {
			WindowEventHelper.add("keydown", this.handleKeyDown)

            document.body.className = "scroll_hide";
        }
        else {
			WindowEventHelper.remove("keydown", this.handleKeyDown)

            document.body.className = "";
        }
    }

    @autobind
    handleKeyDown(e) {
        const keyCode = e.keyCode;
        const tagName = e.target.tagName;
        if (keyCode == 27) {
            this.props.handlePopupClose();
        }
    }

    render() {
        const divStyle = {position: 'fixed', display: this.props.isPopupOpened?'block':'none'};
        return (
            <div className="container_layer" style={divStyle}>
                <ClearDataResultPopup />
                <CloseBlogResultPopup/>
            </div>
        );
    }
}

export default BlogDataPopupLayer
